import { apiClient } from './api-client'
import type { PurchaseHistory } from '@/types/purchaseHistory';

export type CreatePurchaseHistoryPayload = {
  productId: string
  vendorId: string
  quotationId: string | null
  date: string
  price: string
  quantity: string
}

export const purchaseHistoryApi = {
  getPurchaseHistories: (params?: { productId?: string; vendorId?: string }) =>
    apiClient.get<PurchaseHistory[]>('/purchase-histories', { params }),

  getPurchaseHistory: (id: string) => apiClient.get<PurchaseHistory>(`/purchase-histories/${id}`),

  createPurchaseHistory: (payload: CreatePurchaseHistoryPayload) =>
    apiClient.post<PurchaseHistory>('/purchase-histories', payload, undefined, true),
}
